export default function assertAssetURL(src) {
  return src?.replace(
    'https://a.storyblok.com/f',
    'https://assets.consumidorpositivo.com.br/f'
  );
}
